import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchLicenseAccessDetails = createAsyncThunk('widgetAccess/fetchLicenseAccessDetails', async () => {
  try {
    const apiEndpoint = `/license`;

    return await api
      .get(apiEndpoint, {
        headers: {
          'content-type': 'application/json',
        },
      })
      .then(function (response) {
        if (response) {
          return response.data;
        } else {
          return null;
        }
      });
  } catch (error) {
    console.error('Error fetching initial state:', error);
    return [];
  }
});
